import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class AgenciesService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('agencies/search', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('agencies/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('agencies/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('agencies/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('agencies/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('agencies/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('agencies/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('agencies/delete', val_id);
  }
}
